<template>
  <div>
    <div>
      <el-container>
        <el-aside width="340px">
          <div style="text-align: right;width: 96%;color: #2a99ff" @click="selectDeptTree" class="el-icon-refresh"></div>
          <div style="height: 75vh;overflow: auto" v-loading="deptLoading">
            <el-tree :data="deptTree" node-key="id" :default-expanded-keys="[1,3]">
            <span slot-scope="{ node, data }" style="width: 88%" @click="clickDept(data)">
              <el-popover placement="right" width="160" trigger="hover">
                <div>
                  <div style="margin:4px 0 12px 0">
                    <div style="font-weight: bold;margin: 0px 0 4px 0;text-align: center">负责人</div>
                    <div style="display: flex;justify-content: space-around;color: #909399;cursor: pointer;" @click="updateItem(data)">
                      <div style="width: 50%" class="text-ellipsis">
                        <span v-if="data.director">{{ data.director.coachName }}</span>
                        <span v-else style="color: #ff4d4f">设置</span>
                      </div>
                      <div style="width: 50%" class="text-ellipsis">
                        <span v-if="data.viceDirector">{{ data.viceDirector.coachName }}</span>
                        <span v-else style="color: #ff4d4f">设置</span>
                      </div>
                    </div>
                  </div>
                  <el-button-group>
                    <el-button size="small" @click="updateItem(data)" type="danger">编辑部门</el-button>
                    <el-button size="small" @click="createdItem(data)" type="danger">添加子级</el-button>
                  </el-button-group>
                </div>
                <template #reference>
                  <div class="custom-tree-node">
                    <div style="font-size: 13px;">{{ data.name }}</div>
                  </div>
                </template>
              </el-popover>
            </span>
            </el-tree>
          </div>

        </el-aside>
        <el-main>
          <div style="margin-bottom: 20px">
            <el-popover placement="top" width="200" trigger="click">
              <div>
                <div style="margin-bottom: 10px;font-weight: bold">分配角色</div>
                <el-select v-model="setDeptCoachId" style="width: 180px;margin:0 10px"
                           filterable placeholder="请选择分配人" :loading="choiceCoachLoading"
                           remote reserve-keyword :remote-method="selectCoach">
                  <el-option v-for="(coach,index) in choiceCoachList" :key="index" :label="coach.name" :value="coach.id">
                    {{coach.id}} - {{coach.name}}
                  </el-option>
                </el-select>
              </div>
              <el-button :disabled="tableQuery.deptName == null" slot="reference" type="danger" style="margin-right: 10px">新 增</el-button>
            </el-popover>

            <el-tooltip class="item" effect="dark" content="点击左侧树解构进行切换！" placement="top">
              <el-input v-model="tableQuery.deptName" disabled style="width: 200px" @change="selectCoachPage" placeholder="请选择左侧树结构"></el-input>
            </el-tooltip>

            <el-input v-model="tableQuery.coachName" style="width: 200px;margin-left: 10px" @change="selectCoachPage" placeholder="请输入姓名"></el-input>
          </div>
          <el-table border class="table" :data="tableData"  height="600px" :cell-style="{padding:0+'px'}" v-loading="tableQuery.loading"
                    :empty-text="tableQuery.deptId == null ? '请选择左侧树结构':'未查询到数据'">
            <el-table-column width="70" property="coachId" label="ID"></el-table-column>
            <el-table-column width="180" property="coachName" show-overflow-tooltip label="姓名">
              <template #default="coach">
                <div  style="display:flex;align-items: center">
                  <el-image style="width: 35px; height: 35px;border-radius: 6px;margin: 6px 10px 6px 0" :src="coach.row.portrait" :preview-src-list="[coach.row.portrait]">
                    <div slot="error" class="image-slot" style="display: flex;justify-content: center;">
                      <span class="el-icon-picture-outline" style="margin-top: 10px"></span>
                    </div>
                  </el-image>
                  <el-tooltip class="box-item" effect="dark" :content="coach.row.coachName" placement="top">
                    <div>{{ coach.row.coachName | truncate }}</div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="workNumber" label="工号"></el-table-column>
            <el-table-column property="coachPhone" show-overflow-tooltip label="电话"></el-table-column>
            <el-table-column property="dept.name" show-overflow-tooltip label="部门"></el-table-column>
            <el-table-column property="" show-overflow-tooltip label="校区"></el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template #default="scope">
                <div style="display: flex;justify-content: start;margin-left: 6px">
                  <el-button style="margin: 0" type="danger" @click.prevent="deleteItem(scope.row)" slot="reference" size="mini">移 除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              style="text-align: right;margin: 20px 10px"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="tableQuery.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="tableQuery.total">
          </el-pagination>
        </el-main>
      </el-container>
    </div>
    <update-dept @succeed="selectDeptTree" ref="update"></update-dept>
    <created-dept @succeed="selectDeptTree" ref="created"></created-dept>
  </div>
</template>

<script>
import '/src/assets/styles.css';
import {selectDeptTree,selectCoachPageByDeptId} from '/src/api/contacts/dept'
import UpdateDept from "./UpdateDept";
import CreatedDept from "./CreatedDept";
import {selectCoach} from "../../../../api/contacts/user";

export default {
  name: "Dept",
  components:{UpdateDept,CreatedDept},
  data() {
    return {
      deptTree: [],
      deptLoading:false,
      tableQuery:{
        deptId:null,
        deptName:null,
        coachName:"",
        pageIndex:0,
        pageSize:100,
        total:0,
        loading:false
      },
      tableData: [],
      setDeptCoachId:null,
      choiceCoachList:[],
      choiceCoachLoading:false,
    }
  },
  methods:{
    createdItem(item){
      this.$refs.created.openDialog(item,this.deptTree);
    },
    updateItem(item){
      this.$refs.update.openDialog(item,this.deptTree);
    },
    /**
     * 选择部门
     */
    clickDept(dept){
      this.tableQuery.deptId = dept.id;
      this.tableQuery.deptName = dept.name;
      this.selectCoachPage();
    },
    /**
     * 根据部门Id查询教练列表
     */
    selectCoachPage(){
      this.tableQuery.loading = true;
      selectCoachPageByDeptId(this.tableQuery).then(val=>{
        if (val.status){
          this.tableData = val.data.list;
          this.tableQuery.loading = false;
          this.tableQuery.total = val.data.total;
        }
      })
    },
    deleteItem(){
      this.$notify({title: '提醒', message:"功能开发中...",type:'warning', offset: 40});
    },
    selectDeptTree(){
      this.deptLoading = true;
      selectDeptTree().then(val=>{
        if (val.status){
          this.deptTree = val.data;
          this.deptLoading = false;
        }
      })
    },
    selectCoach(val){
      this.choiceCoachLoading = true;
      selectCoach({coachName:val ? val:''}).then(val=>{
        this.choiceCoachLoading = false;
        this.choiceCoachList = val.data;
      })
    },
  },
  created() {
    if (localStorage.getItem("deptTreePrincipal")){
      this.deptTree = JSON.parse(localStorage.getItem("deptTreePrincipal"));
    }else {
      this.deptLoading = true;
      setTimeout(() => {
        this.deptLoading = false;
        this.deptTree = JSON.parse(localStorage.getItem("deptTreePrincipal"));
      }, 4000);
    }
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 10px 10px 10px;
  height: 550px;
}
.el-aside {
  text-align: center;
  padding: 14px 6px 14px 14px;
  margin: 10px 10px;
  border-radius: 16px;
  box-shadow: 0 0px 20px 0 rgba(94, 93, 93, 0.1);
}
.text-ellipsis {
  text-align: center;
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;         /* 隐藏溢出内容 */
  text-overflow: ellipsis;  /* 显示省略号 */
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  width: 100%;
}
</style>